<section>
  <mat-form-field class="example-full-width">
    <input
      #inputRef
      id="inputRef"
      matInput
      [matAutocomplete]="auto"
      [formControl]="autoCompleteTextInput"
      >
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="updateValue($event)">
      @for (gp of filteredOptions | async; track gp) {
        <mat-option [value]="gp">
          {{ gp.text }}@if (gp.info) {
          <span class="ps-2 text-muted text-small">{{gp.info}}</span>
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
</section>
